import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-password",
  "use": "icon-password-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 400 400\" id=\"icon-password\">\n<style type=\"text/css\">\n\t#icon-password .st0{fill:#2174ff;}\n</style>\n<title>lock</title>\n<g id=\"icon-password_未标题-1.psd\">\n\t<g id=\"icon-password__-s-lock_icon\">\n\t\t<path class=\"st0\" d=\"M324,145h-30c0-51.4-41.6-93-93-93s-93,41.6-93,93H78c0-67.9,55.1-123,123-123S324,77.1,324,145z\" />\n\t\t<path class=\"st0\" d=\"M306,382H96c-41.4,0-75-33.6-75-75v-90c0-41.4,33.6-75,75-75h210c41.4,0,75,33.6,75,75v90\n\t\t\tC381,348.4,347.4,382,306,382z M96,172c-24.8,0-45,20.2-45,45v90c0,24.8,20.2,45,45,45h210c24.8,0,45-20.2,45-45v-90\n\t\t\tc0-24.8-20.2-45-45-45H96z\" />\n\t\t<path class=\"st0\" d=\"M239.9,217h-77.8c-8.3,0-15,6.7-15,15l0,0v6.1c0,8.3,6.7,15,15,15h21.1V307c0,9.8,8,17.8,17.8,17.8\n\t\t\tc9.8,0,17.8-8,17.8-17.8v-53.9h21.1c8.3,0,15-6.7,15-15V232C254.9,223.7,248.2,217,239.9,217L239.9,217z\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/password.svg
// module id = QjmH
// module chunks = 35